"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.getMinDate = exports.getMaxDate = exports.getEegkeys = exports.filterRegulationsByEeg = exports.filterRegulationsByDate = void 0;
exports.loadCurrentRegulations = loadCurrentRegulations;
exports.setSelectedDate = setSelectedDate;
exports.setSelectedEegKey = setSelectedEegKey;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regulationApi = _interopRequireDefault(require("../api/regulationApi"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_CURRENT_REGULATIONS = 'api/reducer/regulations/GET_REGULATIONS';
var SET_SELECTED_EEG = 'api/reducer/regulations/SET_AVAILABLE_EEGS';
var SET_SELECTED_DATE = 'api/reducer/regulations/SET_SELECTED_DATE';
var SET_TO_LOADING = 'api/reducer/regulations/SET_TO_LOADING';
var REGUL_API_ERROR = 'api/reducer/regulations/REGUL_API_ERROR';
// Reducer
var filterRegulationsByEeg = exports.filterRegulationsByEeg = function filterRegulationsByEeg(regulations, eegId) {
  if (!regulations || !regulations.length || !eegId) {
    return [];
  }
  return regulations.filter(function (reg) {
    return eegId === reg.eegInstallationId;
  });
};
var filterRegulationsByDate = exports.filterRegulationsByDate = function filterRegulationsByDate(regulations, from, to) {
  if (!regulations || !regulations.length || !from || !to) {
    return [];
  }
  return regulations.filter(function (reg) {
    return reg.regulationIntervalTimeStamps.start >= from && to >= reg.regulationIntervalTimeStamps.start;
  });
};
var getMaxDate = exports.getMaxDate = function getMaxDate(regulations) {
  if (!regulations || !regulations.length) {
    return 0;
  }
  var currMax = regulations[0].regulationIntervalTimeStamps.end;
  regulations.forEach(function (reg) {
    if (currMax < reg.regulationIntervalTimeStamps.end) {
      currMax = reg.regulationIntervalTimeStamps.end;
    }
  });
  return currMax;
};
var getMinDate = exports.getMinDate = function getMinDate(regulations) {
  if (!regulations || !regulations.length) {
    return 0;
  }
  var currMin = regulations[0].regulationIntervalTimeStamps.start;
  regulations.forEach(function (reg) {
    if (currMin > reg.regulationIntervalTimeStamps.start) {
      currMin = reg.regulationIntervalTimeStamps.start;
    }
  });
  return currMin;
};
var getEegkeys = exports.getEegkeys = function getEegkeys(regulations) {
  var eegs = [];
  regulations.forEach(function (reg) {
    var id = reg.eegInstallationId;
    if (!eegs.find(function (eeg) {
      return eeg === id;
    })) {
      eegs.push(id);
    }
  });
  return eegs;
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case LOAD_CURRENT_REGULATIONS:
      {
        var eegKeys = getEegkeys(action.data.innerData);
        return _objectSpread(_objectSpread({}, state), {}, {
          regulations: action.data.innerData.map(function (elem) {
            return _objectSpread(_objectSpread({}, elem), {}, {
              regulationIntervalTimeStamps: {
                start: elem.regulationIntervalTimeStamps.start * 1000,
                end: elem.regulationIntervalTimeStamps.end * 1000
              }
            });
          }),
          errorCode: null,
          availableEegs: eegKeys,
          selectedEeg: eegKeys && eegKeys.length ? eegKeys[0] : null,
          loading: false
        });
      }
    case SET_SELECTED_EEG:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedEeg: action.data.eegKey
      });
    case SET_SELECTED_DATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedStartDate: action.data.from,
        selectedEndDate: action.data.to
      });
    case SET_TO_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case REGUL_API_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        regulations: [],
        errorCode: action.data.error
      });
    default:
      return state;
  }
}

// Action Creators
function loadCurrentRegulations(dispatch, contractId) {
  dispatch({
    type: SET_TO_LOADING
  });
  var resp = (0, _regulationApi.default)(contractId);
  return resp.then(function (reponse) {
    dispatch({
      type: LOAD_CURRENT_REGULATIONS,
      data: {
        innerData: reponse.data ? reponse.data.content : []
      }
    });
  }).catch(function (err) {
    var errorCode;
    if (err.response.data.errors[0] && err.response.data.errors[0].code) {
      errorCode = err.response.data.errors[0].code.split('.').pop();
    }
    dispatch({
      type: REGUL_API_ERROR,
      data: {
        error: errorCode
      }
    });
  });
}
function setSelectedEegKey(dispatch, eegKey) {
  dispatch({
    type: SET_SELECTED_EEG,
    data: {
      eegKey: eegKey
    }
  });
}
function setSelectedDate(dispatch, from, to) {
  dispatch({
    type: SET_SELECTED_DATE,
    data: {
      from: from,
      to: to
    }
  });
}